__turbopack_context__.v({
  "form": "calculator-module-scss-module__ZFW3Za__form",
  "headline": "calculator-module-scss-module__ZFW3Za__headline",
  "mobile-headline": "calculator-module-scss-module__ZFW3Za__mobile-headline",
  "placeholder": "calculator-module-scss-module__ZFW3Za__placeholder",
  "unit": "calculator-module-scss-module__ZFW3Za__unit",
});
